import { INSERT_TEMP, CLEAR_TEMP } from '../actions/tempActions';

/**
 * Reducer to update the site language
 * @param {object} state
 * @param {object} action
 */
function temp(
  state = {}, 
  action) {
  switch (action.type) {
    case INSERT_TEMP:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_TEMP:
      return {};

    default:
  }

  return state;
}

export default temp;
